/*
 *   Copyright (c) 2021 vlinder Inc.
 *   All rights reserved.
 *   This software is proprietary of vlinder Inc. and can not be distributed / used for any purpose outside of vlinder Inc. without explicit written consent from the copyright owner.
 */

export const App_config = {
  appId: '1.0.0',
  appName: 'Trag Admin Portal',
};

export const breakpointSize = {
  mobileS: '320px',
  mobileM: '375px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '2560px',
};

export const device = {
  mobileS: `(min-width: ${breakpointSize.mobileS})`,
  mobileM: `(min-width: ${breakpointSize.mobileM})`,
  mobileL: `(min-width: ${breakpointSize.mobileL})`,
  tablet: `(min-width: ${breakpointSize.tablet})`,
  laptop: `(min-width: ${breakpointSize.laptop})`,
  laptopL: `(min-width: ${breakpointSize.laptopL})`,
  desktop: `(min-width: ${breakpointSize.desktop})`,
  desktopL: `(min-width: ${breakpointSize.desktop})`,
};
